"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  name: 'image',
  element: '.intro-banner-image img',
  type: 'image'
}, {
  name: 'mobileImage',
  element: '.intro-banner-image',
  type: 'mobileImage'
}, {
  name: 'video',
  element: '.intro-banner-video source',
  type: 'video'
}, {
  name: 'embeddedVideo',
  element: '.intro-banner-video-external iframe',
  type: 'iframe'
}, {
  name: 'content',
  element: '.intro-banner-text',
  type: 'html'
}, {
  name: 'link',
  element: '.intro-banner-link',
  type: 'html'
}, {
  name: 'anchorLink',
  element: '.sticky-downlink a',
  type: 'link'
}, {
  name: 'textList',
  element: '.intro-banner-list-spot-content',
  type: 'list'
}];
exports["default"] = _default;